import {FC, useMemo, useState} from "react";
import {usePermissions} from "../../../resources/PermissionsHook";
import {useNavigate} from "react-router-dom";
import {SettingsContainer} from "../SettingsPage";
import {Card} from "@jane/lib/src/components/Card";
import {Button} from "@jane/lib/src/components/form/Button";
import {SettingMap} from "../../../../../lib/src/api";
import {useApiCall} from "@jane/lib/src/api";
import {useToasts} from "@jane/lib/src/toasts/toasts";
import {Toggle} from "@jane/lib/src/components/form/Toggle";
import {Input} from "../../../../../lib/src/components/form/Input";
import {config} from "../../../config";

export const TelephonePreferences: FC<{ settings?: SettingMap, onUpdated?: () => Promise<void> }> = (props) =>  {
  return <SettingsContainer title={"Telefooncentrale"} description={"Instellingen voor de telefooncentrale. Hier kunnen teams aan belgroepen gekoppeld worden."}>
    <div className={'flex flex-col gap-y-4'}>
      <CallCenterCard />
      <CallbackTemplateCard />
      {props.settings && <CallCenterSettings settings={props.settings} onUpdated={props.onUpdated} />}
    </div>
  </SettingsContainer>
}

const CallCenterCard: FC = () => {
  const navigate = useNavigate()
  return <Card title={'Telefooncentrale'}>
    <Button type={"primary"} size={'sm'} onClick={() => navigate('/settings/telephone')} text={'Teams en belgroepen instellen'} />
  </Card>
}

const CallbackTemplateCard: FC<{}> = () => {
  const navigate = useNavigate()
  return <Card title={'Terugbel sjablonen'}>
    <Button type={"primary"} size={'sm'} onClick={() => navigate('/settings/callback_templates')} text={'Terugbel sjablonen beheren'} />
  </Card>
}

const CallCenterSettings: FC<{settings: SettingMap, onUpdated?: () => Promise<void> }> = (props) => {
  const { canManageAppPreferences } = usePermissions()
  const { settings: settingsApi } = useApiCall(config)
  const {showToast} = useToasts()

  const [phoneNumber, setPhoneNumber] = useState<string>(props.settings.medewerkers_call_center_nummer !== null ? String(props.settings.medewerkers_call_center_nummer) : '')
  const [isEnabled, setIsEnabled] = useState<boolean>(Boolean(props.settings.medewerkers_call_center_enabled) ?? false)

  const isDirty = useMemo(() => {
    return phoneNumber !== String(props.settings.medewerkers_call_center_nummer) || isEnabled !== Boolean(props.settings.medewerkers_call_center_enabled);
  }, [phoneNumber, isEnabled])

  if (! canManageAppPreferences) {
    return <></>
  }

  const save = async () => {
    await settingsApi.update({
      medewerkers_call_center_enabled: isEnabled ? 1 : 0,
      medewerkers_call_center_nummer: phoneNumber,
    }).then(() => {
      showToast('Opgeslagen', "Uw wijzigingen zijn opgeslagen.")
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    await props.onUpdated?.()
  }

  return <div className={'flex flex-col gap-y-4 bg-brand-secondary-container px-6 py-4 rounded-xl'}>
    <div className={"text-lg font-medium"}>Medewerkers doorsturen</div>
    <div className={'text-sm text-brand-secondary'}>
      Als deze optie aan staat worden alle medewerkers (op basis van hun telefoonnummers uit ONS) automatisch
      doorgestuurd naar het opgegeven nummer. Dit kan een extensie of een intern nummer uit de telefooncentrale zijn.
    </div>
    <label className={'flex flex-row items-center justify-between min-h-10 mb-2'}>
      <div className={'text-sm font-medium text-brand-900'}>Doorsturen in call-router:</div>
      <Toggle value={isEnabled} onChange={() => setIsEnabled(!isEnabled)}/>
    </label>
    <label className={'flex flex-row items-center justify-between min-h-10 mb-2'}>
      <div className={'text-sm font-medium text-brand-900 whitespace-nowrap'}>Doorsturen naar nummer:</div>
      <div className={'-mt-1 w-48'}>
        <Input type={'text'} label={''} value={phoneNumber} onChange={setPhoneNumber} />
      </div>
    </label>



    <Button type={'primary'} size={'sm'} disabled={!isDirty || phoneNumber === ''} text={'Opslaan'} onClick={() => save()} />
  </div>
}